module.exports = __webpack_public_path__ + "assets/cb1ea0517b67954cd399f65b3b333bf9.png";